export default {
  NORMAL: "normal",
  ITALIC: "italic",
  OBLIQUE: "oblique"
};
